import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { MySharedService } from '../App/shared.service';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/ReleaseLogs/releaselogs.html'
})

export class ReleaseLogsComponent implements OnInit {
    userDetail: any;
    public constants: Constants;
    public applications: any[] = [];

    public customers: any[] = [];

    public users: any[] = [];
    public applicationReleaseLogs : any[] = []; 

    public lastLogDate : Date = new Date("01/01/2017");

    public addApplicationData: any = { 
        addApplicationCustomerId: "",
        addApplicationStatus:true 
    };

    public addApplicationLogData: any = { 
            
    };

    filter: any = {};

    isEditLog :boolean = false;

   public filterCustomerStatus: any = "";
   public filterUserStatus: any = "";

    public EditApplicationData: any = { 
        editApplicationCustomerId: "" 
    };

    public selectedApplicationLog: any = {};

    public selectedApplication:any = {};

    public isAdd: boolean = true;
    active = true;
    public showLoader = false;
    public existsApplicationName: boolean = false;
    public isFormSubmitted: boolean = false;

    showVersionBtn: boolean = false;

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private _datepipe: DatePipe,private activatedRoute: ActivatedRoute,
        private _Router: Router) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.filterCustomerStatus = this.constants.enumCustomerStatus["Active"];
        this.filterUserStatus = this.constants.enumUserStatus["Active"];

        this.filter = { 'ApplicationId': ''};

        this.activatedRoute.queryParams.subscribe(
            (param: any) => {
                if (param["appid"]) {
                    this.filter.ApplicationId = param["appid"];
                }
            });

        

    }

    newForm() {
        this.active = false;
        setTimeout(() => this.active = true, 0);
    }

    ngOnInit() {
     //   this.getApplications();
     //   this.getCustomers();
        this.getUsers();

        this.BindFilters();        

        if(this.filter.ApplicationId != null && this.filter.ApplicationId != ""){
            this.getApplicationLogs();
        }


    }

    ExportItems() {
        
    }

    public clearFilter() {
        
            this.filter = { 'ApplicationId': ''};
    }

    ngAfterViewInit() {
        $("#show-filter").click(function () { $(".filter-form").slideToggle() });       

        $("#show-filter").click(function () {
            $(".filter-form").slideToggle();           
        }).bind(this);    

         

    }

    public onApplicationSelected(value: any){
        
        if(this.isEditLog)
            return;

        var tempReleaseNum;
        this.applications.forEach(element => {
            tempReleaseNum = element.ReleaseNumber;
            
            if(element.ApplicationId == value){
                this.selectedApplication = element;
                this.OnGreater();

                if(tempReleaseNum == "" || tempReleaseNum == null){

                    tempReleaseNum = "1.0";
                    this.showVersionBtn = false;
                    
                }else{

                    var releaseNums = element.ReleaseNumber.toString().split('.');
                    var marjorReleaseNo = releaseNums[0];
                    var minorReleaseNo = releaseNums[1];
                    if(minorReleaseNo == null)
                    minorReleaseNo = "0";

                    tempReleaseNum = marjorReleaseNo + "." + (parseInt(minorReleaseNo) + 1);

                    this.showVersionBtn = true;
                }
                
                this.addApplicationLogData.addApplicationLogReleaseNo = tempReleaseNum;
                
                
            //    this.onLogDateChange(element.ReleaseDate);    
            }
        });
    }

    onChangeVersionNumber(){
        if(this.addApplicationLogData.addApplicationLogReleaseNo == "" || this.addApplicationLogData.addApplicationLogReleaseNo == null)
            return;
        
        this.showVersionBtn = false;

        var releaseNums = this.addApplicationLogData.addApplicationLogReleaseNo.toString().split('.');
        var marjorReleaseNo = releaseNums[0];
        var minorReleaseNo = releaseNums[1];

        this.addApplicationLogData.addApplicationLogReleaseNo = (parseInt(marjorReleaseNo) + 1) + ".0";
    
    }


     public OnGreater() {
            if(this.selectedApplication.ReleaseDate != null && this.selectedApplication.ReleaseDate != "")
            {            
                
                var tLastLogDate = moment(this.selectedApplication.ReleaseDate, "DD/MM/YYYY");
                var tSelectedDate = moment($("[name=addApplicationLogReleaseDate]").val(), "DD/MM/YYYY");
                if (tSelectedDate < tLastLogDate) {

                    this._sharedService.ShowMessage("warning|Release Date should be greater than Last Release Date; Last Release Date is "+ this.selectedApplication.ReleaseDate);
                    
                    this.addApplicationLogData.addApplicationLogReleaseDate = this.selectedApplication.ReleaseDate;
                    var ts = this.selectedApplication.ReleaseDate;
                    $("[name=addApplicationLogReleaseDate]").val(ts);
                    
         
                } else {
                    //this.greater = false;
                }

            }

        }

    

    public addApplicationFormLoad() {
       // $('#btnaddApplicationForm').trigger('click');    
        
    }

    public ResetForm(form: any) {
        form.reset();
        form.resetForm();
        this.isFormSubmitted = false;
    }


    public BindFilters() {
        this.getApplications();
    }

    public getCustomers() {
        this.showLoader = true;
        this._httpService.ajaxPost('Customer/GetCustomer', { "CustomerId": 0, "CountryId": 0, "CustomerStatus": this.filterCustomerStatus }).subscribe(
            data => {
                this.customers = data["CustomerList"];
             //   console.log(this.customers);
             this.customers.sort(function (a, b) {
                if (a.Customer_Name.toLowerCase() < b.Customer_Name.toLowerCase()) return -1;
                if (a.Customer_Name.toLowerCase() > b.Customer_Name.toLowerCase()) return 1;
                return 0;
            })

            },
            err => {
                this.showLoader = false;
            },

            () => {
                this.showLoader = false;

            }
        );
    }
    

    public getApplications() {
        this.showLoader = true;

        this._httpService.ajaxPost('Application/getApplication', null
        ).subscribe(
            data => {
                this.applications = data["Application"];
                 this.applications.forEach(element => {
                    element.ReleaseDate = this._datepipe.transform(element.ReleaseDate, 'dd/MM/yyyy');
                });
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public getUsers() {
        this.showLoader = true;
        this._httpService.ajaxPost('Users/GetAllUsers', {
            "IsActive": this.filterUserStatus
        }).subscribe(
        data => {
            this.users = data["Users"];
        },
        err => {
            this.showLoader = false;
            this._sharedService.ShowMessage(this.constants.globalError);
        },

        () => {
            this.showLoader = false;
        }
        );
    }


    public getApplicationLogs() {
        var appId;
        appId = this.filter.ApplicationId;

        if(appId == "" || appId == null){
            return;
        }

        this.showLoader = true;
        this._httpService.ajaxPost('Application/GetApplicationReleaseLogs', {
            "ApplicationId": appId
        }).subscribe(
            data => {
                this.applicationReleaseLogs = data["ApplicationReleaseLogs"];
                // this.applicationReleaseLogs.forEach(element => {
                //     element.ReleaseDate = this._datepipe.transform(element.ReleaseDate, 'dd/MM/yyyy');
                // });
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },

            () => {
                this.showLoader = false;
            }
            );
    }


    // item param is from grid
    public getApplicationLogsOld(item: any) {

        this.showLoader = true;
        this._httpService.ajaxPost('Application/GetApplicationReleaseLogs', {
            "ApplicationId": item.ApplicationId
        }).subscribe(
            data => {
                this.applicationReleaseLogs = data["ApplicationReleaseLogs"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },

            () => {
                this.showLoader = false;
            }
            );
    }

    public editLog(item: any){

        $('#btnaddEditApplicationLogForm').trigger('click');
        this.selectedApplicationLog = item;
        this.isEditLog = true;
        this.showVersionBtn = false;
        this.addApplicationLogData.addApplicationLogApplicationReleaseLogId = item.ApplicationReleaseLogId;
        this.addApplicationLogData.addApplicationLogApplicationId = item.ApplicationId;
        this.addApplicationLogData.addApplicationLogReleaseBy = item.ReleaseBy;
        this.addApplicationLogData.addApplicationLogReleaseDate = item.ReleaseDate;
        this.addApplicationLogData.addApplicationLogReleaseNote = item.ReleaseNote;
        this.addApplicationLogData.addApplicationLogReleaseNo = item.ReleaseNumber;

    }

    public viewFullLog(item: any){
        $('#btnaddEditApplicationLogForm').trigger('click');
        this.selectedApplicationLog = item;

    }

     public addEditApplicationLogFormLoad() {

        $('#btnaddEditApplicationLogForm').trigger('click');

        this.isEditLog = false;

         var today = moment().format('YYYY-MM-DD');

        setTimeout(function() {
            $('.date').datetimepicker({
                format: 'DD/MM/YYYY',
                maxDate: today
            })
        }, 100);
            
         this.addApplicationLogData = { 
            addApplicationLogApplicationId:"",
            addApplicationLogReleaseBy:""
        };

         this.newForm();


        this.addApplicationLogData.addApplicationLogApplicationId = this.filter.ApplicationId;
        this.addApplicationLogData.addApplicationLogReleaseBy = null;
        this.addApplicationLogData.addApplicationLogReleaseBy = this.userDetail.SiteUserId
        var sd = this._datepipe.transform(today, 'dd/MM/yyyy');
        this.addApplicationLogData.addApplicationLogReleaseDate = sd;
     
        this.onApplicationSelected(this.filter.ApplicationId);

    }

    public CancelAddApplicationLog() {
        this.selectedApplication = {};
        this.addApplicationLogData = { 
            addApplicationLogApplicationId:"",
            addApplicationLogReleaseBy:null
        };

        this.newForm();
        $('#addEditApplicationLogForm').modal('hide');
        
    }

    public CancelEditApplication() {
        this.selectedApplication = {};
        this.selectedApplicationLog = {};
        this.newForm();
        $('#EditApplication').modal('hide');
        this.isAdd = true;
    }

    public addApplicationLog(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid) {
                let objItem: any = {};
                if(this.addApplicationLogData.addApplicationLogApplicationReleaseLogId == null)
                this.addApplicationLogData.addApplicationLogApplicationReleaseLogId = 0;

                objItem.ApplicationReleaseLogId = this.addApplicationLogData.addApplicationLogApplicationReleaseLogId;
                objItem.ApplicationId = this.addApplicationLogData.addApplicationLogApplicationId;
                objItem.ReleaseBy = this.addApplicationLogData.addApplicationLogReleaseBy;
                objItem.ReleaseDate = $("[name=addApplicationLogReleaseDate]").val();
                objItem.ReleaseNote = this.addApplicationLogData.addApplicationLogReleaseNote;
                objItem.ReleaseNumber = this.addApplicationLogData.addApplicationLogReleaseNo;
                

             //   objItem.ReleaseDate = this._datepipe.transform(objItem.ReleaseDate, 'MM/dd/yyyy');
                this.addUpdateApplicationLog(objItem);
               

                $('#addEditApplicationLogForm').modal('hide');
                this.addApplicationLogData = {};
                this.newForm();
            
        }
    }




    addUpdateApplicationLog(objItem) {

        this.showLoader = true;

        this._httpService.ajaxPost('Application/AddUpdateApplicationReleaseLog', objItem).subscribe(
            data => {
                var msg = data["Status"].Message.split('|');
                if (msg.length > 1) {
                    msg[0] = msg[0].toLowerCase();
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                else {
                    this._sharedService.ShowMessage(data["Status"].Message);
                }

                this.getApplications();
                this.filter.ApplicationId = objItem.ApplicationId;
                this.getApplicationLogs();
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );

        
    }

}


/** WEBPACK FOOTER **
 ** ./TypeScripts/ReleaseLogs/releaselogs.component.ts
 **/